import { render, staticRenderFns } from "./PriceTypeList.vue?vue&type=template&id=6369d0da&scoped=true"
import script from "./PriceTypeList.vue?vue&type=script&lang=js"
export * from "./PriceTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6369d0da",
  null
  
)

export default component.exports